import { IconProps } from "../icon-prop-types";
import cn from "classnames";
import Styles from "../Icon.module.scss";

export const WinnerArrowIcon = (_props: IconProps) => {
  return (
    <>
      <svg
        data-testid="winner-arrow-icon"
        width="8"
        height="15"
        viewBox="0 0 8 15"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g className={cn(Styles.gcGreen, Styles.fill)}>
          <path d="m0 0 8 6.667-8 6.666V0z"></path>
        </g>
      </svg>
    </>
  );
};
